import * as immutable from 'immutable';
import { ABERRATIONS_ACTIONS } from './aberrations.actions';
import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';
import { Ifilter } from '../interfaces/aberrations-filters.interface';
import { IAberrations } from '../interfaces/aberrations.interface';
import { WorkflowDrivenCacheablesEntity } from '../../../workflow-config/entities/workflow-driven-cacheables.entity';
import { CORE_ACTIONS } from '../../../core/constants/core-actions.constant';
import { CastTypes } from '../../../core/utils/type-casting,util';


export interface IAberrationsState {
  filters: immutable.Map<string, IfiltersState>,
  results: immutable.Map<string, immutable.Map<string, IAberrations[]>>,
  filteredResults: immutable.Map<string, string[]>,
  filteredResultsCount: immutable.Map<string, number>,
  opinions: immutable.Map<string, immutable.Map<string, IAberrations[]>>,
  loadingStatus: immutable.Map<string, boolean>
}

export interface IfiltersState {
  active: Ifilter[];
  defaults: Ifilter[];
  privates: Ifilter[];
}

const InitState: IAberrationsState = {
  filters: immutable.Map(),
  filteredResults: immutable.Map(),
  filteredResultsCount: immutable.Map(),
  results: immutable.Map(),
  opinions: immutable.Map(),
  loadingStatus: immutable.Map()
};

export function aberrationsReducer(state: IAberrationsState = InitState, action: IgenomicsAction<WorkflowDrivenCacheablesEntity>): IAberrationsState {
  let results;
  let activeResults;
  let value;
  switch (action.type) {
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS:
    case ABERRATIONS_ACTIONS.INIT:
      return action.payload.init(state, null, InitState);
    case ABERRATIONS_ACTIONS.SET_RESULTS:
      value = action.payload.getValue();
      activeResults = state.results.get(action.payload.getIdentifier()) || immutable.Map();
      results = activeResults && activeResults.has(value.type)
        ? activeResults.get(value.type)
        : immutable.Map();
      results = results.asMutable();
      for (const index in <IAberrations[]> value.aberrations) {
        value.aberrations[index].collapsed = true;
        results.set(value.aberrations[index].id, value.aberrations[index]);
      }
      activeResults = activeResults.set(value.type, results.asImmutable());
      state.results = state.results.set(action.payload.getIdentifier(), new Proxy(activeResults, { }));
      return { ...state};
    case ABERRATIONS_ACTIONS.SET_FILTERED_RESULTS:
      value = action.payload.getValue();
      activeResults = state.filteredResults.get(action.payload.getIdentifier()) || immutable.Map();
      results = activeResults.set(value.type,Array.from(new Set(value.results)));
      state.filteredResults = state.filteredResults.set(action.payload.getIdentifier(),new Proxy(results, {}));
      return {...state};
    case ABERRATIONS_ACTIONS.SET_FILTERED_RESULTS_COUNT:
      value = action.payload.getValue();
      activeResults = state.filteredResultsCount.get(action.payload.getIdentifier()) || immutable.Map();
      results = activeResults.set(value.type, value.count);
      state.filteredResultsCount = state.filteredResultsCount.set(action.payload.getIdentifier(),results);
      return {...state};
    case ABERRATIONS_ACTIONS.SET_FILTER_QUERY:
      value = action.payload.getValue();
      state.filters = action.payload.upsert(state.filters, value.type, { filterQueryString: value.filterQueryString, filterQueryObject: value.filterQueryObject}, CastTypes.MAP);
          return { ...state};
    case ABERRATIONS_ACTIONS.SET_LOADING:
      value = action.payload.getValue();
      state.loadingStatus = action.payload.upsert(state.loadingStatus, value.type, value.status, CastTypes.MAP);
      return { ...state};
    default:
      return state;
  }
}
